// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","AmbasadorBadge":"uw_a zu_jz zu_cy zu_h zu_sv zu_ub zu_ow zu_ok zu_pb zu_pc zu_oj zu_sc"};